var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { AirconIcon, ChildrenIcon, WineGlassIcon, PramIcon, GolfIcon, GymIcon, ParkingIcon, PawIcon, KnifeAndForkIcon, SpaIcon, SwimmingIcon, TelevisionIcon, PoolLadderIcon, WifiIcon, } from '@honeycomb/ui-core';
import React from 'react';
const HOTEL_FACILITY_ICON = {
    AC: AirconIcon,
    BC: PramIcon,
    BA: WineGlassIcon,
    CC: ChildrenIcon,
    GF: GolfIcon,
    GM: GymIcon,
    PK: ParkingIcon,
    PA: PawIcon,
    RS: KnifeAndForkIcon,
    SP: SpaIcon,
    SW: SwimmingIcon,
    TV: TelevisionIcon,
    WN: PoolLadderIcon,
    WP: PoolLadderIcon,
    IN: WifiIcon,
};
export function HotelFacilityIcon(_a) {
    var { facilityCode } = _a, other = __rest(_a, ["facilityCode"]);
    const Icon = HOTEL_FACILITY_ICON[facilityCode] || PawIcon;
    return React.createElement(Icon, Object.assign({}, other));
}
